module.exports = __webpack_public_path__ + "static/media/PBS_NewsHour.9f19b982.png";